import { FC } from 'react';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';

import { MensagemErro } from '../../Formulario/MensagemErro/MensagemErro';
import { BotaoCancelar, BotaoSalvar } from '../../Botao/BotoesComuns';

import { Editor } from '../../Editor/Editor';
import { Formulario } from '../../Formulario/Formulario';
import { OperacaoFormularioCRUD } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';
import { MensagensErroServidor } from '../../MensagensErroServidor/MensagensErroServidor';

import { FormikDebug } from '../../Formulario/FormikDebug';
import { AvaliacaoSelector } from 'store/Avaliacao/Avaliacao.selector';

const Schema = Yup.object().shape({
  comentario: Yup.string().required().label("Comentário"),
});

export interface ReaberturaCamposFormulario {
  comentario: string;
}

interface AvaliacaoFormularioProps {
  onSubmit: (formulario: ReaberturaCamposFormulario) => void;
  onClose: () => void
}

export const ReaberturaFormulario: FC<AvaliacaoFormularioProps> = ({onSubmit, onClose}) => {
  const erros = useSelector(AvaliacaoSelector.formulario.erros);
  const formik = {
    initialValues: {
      notaAvaliacao: undefined,
      comentario: undefined
    },
    validationSchema: Schema,
    onSubmit: onSubmit
  };

  return <Formulario
    formik={formik}
    operacao={OperacaoFormularioCRUD.Criar}
  >
    <MensagensErroServidor erro={erros} />
    <FormikDebug />

    <label htmlFor="comentario">Por que a solicitação não foi atendida?</label>
    <Editor name="comentario" id="comentario" />
    <MensagemErro name="comentario" />

    <footer>
      <BotaoSalvar textoOnLoading="Reabrindo solicitação">Reabrir solicitação</BotaoSalvar>
      <BotaoCancelar type="button" onClick={onClose} />
    </footer>
  </Formulario>;
}
